
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form3";
const form3State = namespace("Form3");

import Form3ProcessHeader from "@/components/process/Form3/components/Form3ProcessHeader.vue";
import Form3 from "@/components/process/Form3/components/pdf/Form3.vue"

import { form3StatusInfoType } from '@/types/Information/Form3';

@Component({
    components:{
        Form3ProcessHeader,
        Form3
    }
})
export default class PreviewForm3 extends Vue {

    @form3State.State
    public currentNoticeOfCrossAppealId: string;

    stepsCompleted = {} as form3StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;         
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form3"}); 
    }
}
